import React from 'react';

import { LazyImportSpacesPage } from '@confluence/site-settings/entry-points/ImportSpacesPage';
import { ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/importSpacesConstants';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminImportSpacesRoute = () => <LazyImportSpacesPage />;

AdminImportSpacesRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
